import { Store } from 'pullstate'

export const InstitutionsStore = new Store({
  institutions: [],
  loading: false,
  error: null,
  current: null,
})
